module.exports = __webpack_public_path__ + "img/Smart Connectivity_ We've been working on more cool stuffs.cb581cb0.png";